import { render } from "./consumelist2.vue?vue&type=template&id=017b5efe"
import script from "./consumelist2.vue?vue&type=script&lang=js"
export * from "./consumelist2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__